import { defineComponent as _defineComponent } from 'vue'
import WalletGuide from '@/components/wallet-guide.vue';
import { useDefaultHK } from '@/hooks/use-default-hk';
import { useDialogManager } from '@/hooks/use-dialog-manager';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { InitEmitMessage, useModuleManagerStore } from '@/store/module-manager';
import { ExtraSortStatus, ModuleName } from '@/types/module-config';
import { CustomException } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';
import { hideLoading, showLoading } from '@tencent/wphk-components-loading';
import { loadScanGiftConf } from '@tencent/wphk-components-scan-gift';
import { onBeforeMount, onMounted, ref, toRefs } from 'vue';
import { useRouter } from 'vue-router/composables';
import { useGlobalBi } from '../../hooks/use-global-bi';
import { useHomeShow } from '../../hooks/use-home-show';
import MerchantInfoModule from './merchant-info-module/index.vue';

// 各个模块初始化完毕后，需要往外层emit("initDone")事件

export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const merchantInfoStore = useMerchantInfo();
const moduleManagerStore = useModuleManagerStore();
const { sortedModuleConfig, initedModule } = toRefs(moduleManagerStore);
const { handleDialogManager } = useDialogManager();
const isLoadFinished = ref(false);
const { getBiExt } = useGlobalBi();
const { beforeHomeShow } = useHomeShow();
const { isDefaultHk } = useDefaultHK();

const router = useRouter();

const handleInitDone = (res: InitEmitMessage) => {
  const { moduleName, message } = res;
  console.log('===home initDone', res);
  // 记录已初始化的模块信息
  moduleManagerStore.updateInitedModule(res);
  // 针对有券的积分组件，需要更新其排序
  if (moduleName === ModuleName.wePointsModule && message?.hasMerchantCoupon) {
    moduleManagerStore.updateModuleConfig({ moduleName, extraSort: ExtraSortStatus.common });
  }
  // 处理弹窗管理器
  handleDialogManager(initedModule.value);
};

const handleSpModuleConfig = () => {
  const targetSpModule = moduleManagerStore.getSpModuleConfig(merchantInfoStore.spId);
  const hiddenModuleNames = moduleManagerStore.getHiddenModuleNames(merchantInfoStore.spId);
  moduleManagerStore.addOrUpdateModuleConfigs(targetSpModule, hiddenModuleNames);
  console.log('===sortedModuleConfig', sortedModuleConfig.value, sortedModuleConfig.value.map(item => item.moduleName));
};

onBeforeMount(() => {
  // TODO:这段代码不应该放在home.vue中
  // 发起加载扫码券礼包配置
  loadScanGiftConf();
});

onMounted(async () => {
  showLoading();
  const [err] = await to(merchantInfoStore.initMerchantInfo());
  hideLoading();
  if (err) {
    // 剔除自动跳转优惠专区场景产生的告警
    if (err.name !== 'merchantNotFound') {
      new CustomException(err, 'initMerchantInfoFail', '商户信息模块初始化失败');
    }
    return;
  }
  /** 处理商户专属模块展示 */
  handleSpModuleConfig();


  // 添加home页面展示之前的钩子，支持根据不同商户执行自定义函数
  console.log('====before exec home show');
  const { isContinue } = await beforeHomeShow({
    merchantId: merchantInfoStore.merchantId,
    spId: merchantInfoStore.spId,
  });
  console.log('====after exec home show, isContinue', isContinue);

  if (!isContinue) {
    return;
  }
  isLoadFinished.value = true;
});



return { __sfc: true,merchantInfoStore, moduleManagerStore, sortedModuleConfig, initedModule, handleDialogManager, isLoadFinished, getBiExt, beforeHomeShow, isDefaultHk, router, handleInitDone, handleSpModuleConfig, WalletGuide, MerchantInfoModule }
}

})